import React, { useCallback } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import _str from "shared/util/_str";
import BoostBoltIcon from "../icons/BoostBolt.svg";

import "./BoostButton.scss";

const BoostButton = ({ tokenCount, hasIncognitoEnabled }) => {
	const text = tokenCount ? _str(`Boost (${tokenCount})`) : _str("GET BOOST");

	const onClick = useCallback(() => window.BoostController.open(), []);

	return (
		<div className="navbar-boost">
			<button
				onClick={onClick}
				className={classnames("navbar-boost-button", {
					disabled: hasIncognitoEnabled,
				})}
				disabled={hasIncognitoEnabled}
			>
				<div className="navbar-boost-button-inner-container">
					<BoostBoltIcon />
					<span className="navbar-boost-text">
						{text}
					</span>
				</div>
			</button>
		</div>
	);
};

BoostButton.defaultProps = {
	tokenCount: 0,
	hasIncognitoEnabled: false,
};

BoostButton.propTypes = {
	tokenCount: PropTypes.number,
	hasIncognitoEnabled: PropTypes.bool,
};

export default BoostButton;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/BoostButton/BoostButton.jsx